module.exports = __webpack_public_path__ + "static/media/add.d5218416.png";